<ng-container *ngIf="renderImageOnBackground && !heroVideo; else inlineContainer">
  <div
    [ngClass]="background + ' hero-banner mobile-background-image'"
    [ngStyle]="{ background: 'url(' + heroMobileImage + ') no-repeat bottom', 'background-size': 'cover' }">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
  <div
    [ngClass]="background + ' hero-banner tablet-background-image'"
    [ngStyle]="{ background: 'url(' + heroTabletImage + ') no-repeat bottom', 'background-size': 'cover' }">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
  <div
    [ngClass]="background + ' hero-banner desktop-background-image'"
    [ngStyle]="{ background: 'url(' + heroImage + ') no-repeat bottom', 'background-size': 'cover' }">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</ng-container>

<ng-template #inlineContainer>
  <div
    #heroBanner
    [class]="background"
    [ngClass]="{ 'hero-banner': true, 'hero-banner-video': heroVideo, 'copy-bold': copyStyle === CopyStyle.bold }">
    <div
      *ngIf="heroBgImage && !heroBgImage.endsWith('undefined')"
      class="image-background desktop"
      [style.background-image]="'url(' + heroBgImage + ')'"></div>
    <div
      *ngIf="heroBgTabletImage && !heroBgTabletImage.endsWith('undefined')"
      class="image-background tablet"
      [style.background-image]="'url(' + heroBgTabletImage + ')'"></div>
    <div
      *ngIf="heroBgMobileImage && !heroBgMobileImage.endsWith('undefined')"
      class="image-background mobile"
      [style.background-image]="'url(' + heroBgMobileImage + ')'"></div>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="imageContainers"></ng-container>
  </div>
</ng-template>

<ng-template #contentTemplate>
  <vm-breadcrumb
    *ngIf="breadcrumb"
    [breadcrumbs]="breadcrumb.breadcrumbs"
    [breadcrumbNumber]="breadcrumb.breadcrumbNumber"
    [theme]="breadcrumb.theme"
    [homePage]="breadcrumb.homePage">
  </vm-breadcrumb>
  <ng-container *ngIf="heroVideo">
    <div class="desktop-background-video">
      <vm-hero-bg-video
        [minScreenSize]="DeviceBreakPoint.Desktop"
        [videoUrl]="heroVideo"
        (intrinsicVideoHeightToWidth)="getDynamicHeight($event)"
        [videoBottomCurve]="true"></vm-hero-bg-video>
    </div>
  </ng-container>
  <ng-container *ngIf="heroTabletVideo">
    <div class="tablet-background-video">
      <vm-hero-bg-video
        [minScreenSize]="DeviceBreakPoint.SmallerTablet"
        [maxScreenSize]="DeviceBreakPoint.Desktop"
        [videoUrl]="heroTabletVideo"
        (intrinsicVideoHeightToWidth)="getDynamicHeight($event)"
        [videoBottomCurve]="true">
      </vm-hero-bg-video>
    </div>
  </ng-container>
  <ng-container *ngIf="heroMobileVideo">
    <div class="mobile-background-video">
      <vm-hero-bg-video
        [maxScreenSize]="DeviceBreakPoint.SmallerTablet"
        [videoUrl]="heroMobileVideo"
        (intrinsicVideoHeightToWidth)="getDynamicHeight($event)"
        [videoBottomCurve]="true"></vm-hero-bg-video>
    </div>
  </ng-container>
  <div class="flare-wrapper" [ngSwitch]="theme" *ngIf="!heroVideo">
    <!--purple-pink-->
    <div *ngSwitchCase="Theme.PurplePink" class="inner-wrapper">
      <img
        id="flare1"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/purplePinkOne.svg'"
        [alt]="'purplePinkOne.svg'"
        data-0="transform:translate(-27.335375191424195%,-35.92763988220446%) rotate(0deg);"
        data-3000="transform:translate(-27.335375191424195%,-35.92763988220446%) rotate(90deg);"
        class="flare purple-pink-a" />
      <img
        id="flare2"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/purplePinkTwo.svg'"
        [alt]="'purplePinkTwo.svg'"
        data-0="transform:translate(20.53892215568862%,90.2970297029703%) rotate(0deg);"
        data-400="transform:translate(20.53892215568862%,90.2970297029703%) rotate(90deg);"
        class="flare purple-pink-b" />
      <img
        id="flare3"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/purplePinkThree.svg'"
        [alt]="'purplePinkThree.svg'"
        data-0="transform:translate(182.5242718446602%,208.00865800865802%) rotate(0deg);"
        data-1000="transform:translate(182.5242718446602%,208.00865800865802%) rotate(90deg);"
        class="flare purple-pink-c" />
    </div>
    <!--blue-green -->
    <div *ngSwitchCase="Theme.BlueGreen" class="inner-wrapper">
      <img
        id="flare1"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/blueGreenTwo.svg'"
        [alt]="'blueGreenTwo.svg'"
        data-0="transform:translate(154.04%,314.76%) rotate(0deg);"
        data-1000="transform:translate(154.04%,314.76%) rotate(-90deg);"
        class="flare blue-green-b" />
      <img
        id="flare2"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/blueGreenOne.svg'"
        [alt]="'blueGreenOne.svg'"
        data-0="transform:translate(52.57%,695.57%) rotate(0deg);"
        data-1500="transform:translate(52.57%,695.57%) rotate(-90deg);"
        class="flare blue-green-a" />
      <img
        id="flare3"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/blueGreenThree.svg'"
        [alt]="'blueGreenThree.svg'"
        data-0="transform:translate(388.97%,76.77%) rotate(0deg);"
        data-500="transform:translate(388.97%,76.77%) rotate(-90deg);"
        class="flare blue-green-c" />
    </div>
    <!--orange-yellow-->
    <div *ngSwitchCase="Theme.OrangeYellow" class="inner-wrapper">
      <img
        id="flare1"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/orangeYellowOne.svg'"
        [alt]="'orangeYellowOne.svg'"
        data-0="transform:translate(0%,95.07%) rotate(0deg);"
        data-500="transform:translate(0%,95.07%) rotate(90deg);"
        class="flare orange-yellow-a" />
      <img
        id="flare2"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/orangeYellowThree.svg'"
        [alt]="'orangeYellowThree.svg'"
        data-0="transform:translate(329.64%,259.07%) rotate(0deg);"
        data-1000="transform:translate(329.64%,259.07%) rotate(90deg);"
        class="flare orange-yellow-c" />
      <img
        id="flare3"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/orangeYellowTwo.svg'"
        [alt]="'orangeYellowTwo.svg'"
        data-0="transform:translate(64.83%,199.15%) rotate(0deg);"
        data-1100="transform:translate(64.83%,199.15%) rotate(90deg);"
        class="flare orange-yellow-b" />
    </div>
    <!--blue-purple-->
    <div *ngSwitchCase="Theme.BluePurple" class="inner-wrapper">
      <img
        id="flare1"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/bluePurpleOne.svg'"
        [alt]="'bluePurpleOne.svg'"
        data-0="transform:translate(223.47%,129.99%) rotate(0deg);"
        data-1000="transform:translate(223.47%,129.99%) rotate(90deg);"
        class="flare blue-purple-a" />
      <img
        id="flare2"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/bluePurpleTwo.svg'"
        [alt]="'bluePurpleTwo.svg'"
        data-0="transform:translate(268.05%,225.66%) rotate(0deg);"
        data-1000="transform:translate(268.05%,225.66%) rotate(90deg);"
        class="flare blue-purple-b" />
      <img
        id="flare3"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/bluePurpleThree.svg'"
        [alt]="'bluePurpleThree.svg'"
        data-0="transform:translate(436.84%,245.49%) rotate(0deg);"
        data-400="transform:translate(436.84%,245.49%) rotate(90deg);"
        class="flare blue-purple-c" />
    </div>
    <!--pink-red-->
    <div *ngSwitchCase="Theme.PinkRed" class="inner-wrapper">
      <img
        id="flare1"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/pinkRedOne.svg'"
        [alt]="'pinkRedOne.svg'"
        data-0="transform:translate(4.44%,134.8%) rotate(0deg);"
        data-600="transform:translate(4.44%,134.8%) rotate(-140deg);"
        class="flare pink-red-a" />
      <img
        id="flare2"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/pinkRedTwo.svg'"
        [alt]="'pinkRedTwo.svg'"
        data-0="transform:translate(12.16%,68.57%) rotate(0deg);"
        data-400="transform:translate(12.16%,68.57%) rotate(-20deg);"
        class="flare pink-red-b" />
      <img
        id="flare3"
        [ngClass]="{
          transition: applyTransition === true,
          'no-transition': doNotInitParallax === false && applyTransition === false
        }"
        [src]="assetsPrefix + 'assets/hero/pinkRedThree.svg'"
        [alt]="'pinkRedThree.svg'"
        data-0="transform:translate(139.41%,3.86%) rotate(0deg);"
        data-1000="transform:translate(139.41%,3.86%) rotate(-160deg);"
        class="flare pink-red-c" />
    </div>
  </div>
  <div class="vm-container" [class]="heroVideo ? 'hero-video-content' : 'hero-content'">
    <div class="vm-row">
      <div class="vm-col-xs-12 vm-col-md-10 vm-col-md-offset-1 vm-col-lg-10 vm-col-lg-offset-1 hero-text Hero-Text">
        <h1 class="Hero-Title" [innerHTML]="heroHeader"></h1>
        <div *ngIf="heroText" [innerHTML]="heroText | markdown"></div>
        <div class="hero-button mobile" *ngIf="buttonText">
          <vm-button
            [type]="btnType"
            [level]="btnVariant"
            [href]="buttonLink"
            [size]="btnSize !== null ? btnSize : ButtonSize.MEDIUM"
            [styles]="[btnStyle]"
            (buttonClick)="onOkClicked($event)"
            *ngIf="buttonText"
            >{{ buttonText }}</vm-button
          >
        </div>
        <div class="hero-button desktop" *ngIf="buttonText">
          <vm-button
            [type]="btnType"
            [level]="btnVariant"
            [href]="buttonLink"
            [size]="btnSize !== null ? btnSize : ButtonSize.LARGE"
            [styles]="[btnStyle]"
            (buttonClick)="onOkClicked($event)"
            *ngIf="buttonText"
            >{{ buttonText }}</vm-button
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #imageContainers>
  <ng-container *ngIf="!heroVideo">
    <div class="mobile-image">
      <img src="{{ heroMobileImage }}" alt="" *ngIf="heroMobileImage" />
    </div>
    <div
      *ngIf="!!heroImage && !heroImage.endsWith('undefined')"
      class="hero-image"
      [ngStyle]="{ background: 'url(' + heroImage + ') no-repeat bottom', 'background-size': 'contain' }"></div>
  </ng-container>
</ng-template>
